<div class="vsa-page-container">
  <app-sub-header title="User Registration"></app-sub-header>
  <div class="content-container">
    <div class="registration-form-container">
      <div data-header class="registration-form-title">About You</div>
      <div class="registration-form-content">
        <app-registration-form></app-registration-form>
      </div>
    </div>
  </div>
  <app-footer footerTitle="Request a Login"></app-footer>
</div>
